STUDIP.domReady(STUDIP.SkipLinks.initialize);
